import React, { useEffect } from 'react'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import imgLessHeadache from '../../assets/news-events/LessHeadache.png'
import TextCaption from '../../Components/TextCaption/TextCaption'
import CenterStage from '../../Components/CenterStage/CenterStage'

import LessHeadache_01 from '../../assets/news-events/LessHeadache_01.png'
import LessHeadache_02 from '../../assets/news-events/LessHeadache_02.png'

const LessHeadache = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);

  return (
    <div>

      <div>
        <CenterStage
          imageSrc={imgLessHeadache}
          title={"Less Headache with Maintenance Plans"}
          paragraph="In the day-to-day running of industry, we know that keeping equipment running smoothly is essential to ensuring productivity and avoiding losses. Even so, unexpected failures are still a reality that keeps many managers awake at night. It is precisely to change this scenario that HANSA-FLEX created maintenance plans."
        />
      </div>

      {/* <TextCaption

        paragraph="Text: Gabriela Nascimento and Tatiana Schrader May 21, 2025"
      />

      <TextCaption

        paragraph="May 21, 2025"
      /> */}


      <TextCaption
        title='Why having a maintenance plan makes all the difference'
        paragraph="Taking care of equipment before it presents problems is the best strategy to avoid unexpected downtime. A well-designed maintenance plan ensures scheduled inspections and replacements, increasing the safety and performance of the entire hydraulic and pneumatic system. The result? Fewer unexpected events, more productivity and much more peace of mind."
      />

      <TextCaption
        title='How HANSA-FLEX helps you take care of your operation'
      />
      <br /><br />
      <ImageDescription
        imageSrc={LessHeadache_01}
      />
      <TextCaption
        paragraphs="Each operation has its own particularities, and HANSA-FLEX takes this seriously. It all starts with a complete analysis of your systems . With this information in hand, we put together a tailored maintenance plan , taking into account how the equipment is used, which ones are most critical and the history of failures . Oh, and of course: we only use original parts and have specialized technicians to ensure that everything works perfectly."
      />

      <TextCaption
        title={"Benefits you feel on a daily basis"}
        paragraph="When you entrust the maintenance of your systems to HANSA-FLEX, you will notice the difference straight away:"
        bulletPoints={[
          "More available and reliable equipment.",
          "Less rushing around with emergencies and unforeseen events.",
          "More predictable maintenance costs.",
          "Equipment that lasts much longer.",
          "Support from those who understand the subject, whenever you need it."
        ]}
      />
      <TextCaption
        paragraph='All of this translates into more security, better performance and much smoother management.'
      />

      <ImageDescription
        imageSrc={LessHeadache_02}
      />

      <TextCaption
        title={"Your Operation at the Center of Our Solutions"}
        paragraph="Here at HANSA-FLEX, we know that downtime is synonymous with loss. That’s why we strive to be more than just a supplier: we want to be your partner on your journey to greater efficiency and safety."
      />
      <TextCaption
        paragraph='Want to take the headache out of your routine? Talk to our experts and learn about our preventive and corrective maintenance solutions!'
      />
      <br /><br />
    </div>
  )
}

export default LessHeadache